import { ApiType } from "@gymflow/common";
import { AppointableDTO } from "@gymflow/types";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { appointableQueryKeys } from "./appointableQueryKeys";

export function useAppointable(
  {
    api,
    appointableId,
  }: {
    api: ApiType;
    appointableId: number | null;
  },
  opts?: Omit<UseQueryOptions<AppointableDTO | null>, "queryKey">,
) {
  return useQuery({
    queryKey: appointableQueryKeys.details(appointableId),
    queryFn: async () => {
      return (await api.appointableApi.findById(appointableId as number)).data;
    },
    enabled: !!appointableId,
    ...opts,
  });
}
